import loadable from '@loadable/component'

export const Showcase = loadable(() => import('./Showcase'))
export const ShowcaseText = loadable(() => import('./ShowcaseText'))
export type { ShowcaseProps } from './Showcase'
export type {
  ShowcaseTextProps,
  ShowcaseTextRenderLinkProps
} from './ShowcaseText'
